import React from 'react';
import { COMPANY_INFO } from '../data/staticData';
import ContactForm from '../components/ContactForm';

export default function WarrantiesPage() {

  return (
    <div className="bg-white">
      {/* Garantier Indhold */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-16">
        
        {/* Header */}
        <div className="text-left max-w-4xl space-y-6 mb-12 sm:mb-16">
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-stone-900 tracking-tight uppercase">
            Dine garantier for et godt resultat
          </h1>
          <p className="text-stone-700 text-lg sm:text-xl leading-relaxed">
            De bedste produkter og det bedste håndværk skaber de bedste løsninger. Vi er i Dansk Tagbyg derfor medlem af de bedste og stærkeste kvalitets- og garantiordninger i den danske tagbranche, så du kan være sikker på, at kvalitet, service og sikkerhed er i højsædet.
          </p>
        </div>

        {/* 2-kolonne layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
          
          {/* Venstre sektion - brødtekst */}
          <div className="lg:col-span-8 space-y-10 text-stone-700 text-sm sm:text-base leading-relaxed">
            
            {/* BMI RoofPro -> Swisspearl */}
            <div className="space-y-4">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 uppercase">
                  Swisspearl
                </h2>
                <img
                  src="/_assets/swisspearl-logo.png"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/swisspearl-logo.png';
                  }}
                  alt="Swisspearl logo"
                  className="h-10 sm:h-12 w-auto object-contain self-start sm:self-auto"
                />
              </div>
              <p>
                Som autoriseret samarbejdspartner med Swisspearl leverer vi professionelle tagløsninger af højeste kvalitet. Vi er uddannet og certificeret i korrekt montage af Swisspearls kvalitetsprodukter, hvilket sikrer dig en stærk, æstetisk og holdbar tagløsning.
              </p>
              <p>
                Hos Dansk Tagbyg udfører vi altid arbejdet efter producentens strenge forskrifter og specifikationer. Det betyder, at du får fuld tryghed og markedets bedste garantier på både produkter og materialer.
              </p>
              <p>
                Gennem vores partnerskab med Swisspearl kan vi tilbyde omfattende garantiordninger på tagplader og tilbehør, så dit nye tag er sikret mod det omskiftelige danske vejr i årtier frem.
              </p>
              <p className="pt-2">
                <a
                  href="https://www.swisspearl.com/da-dk"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#BE0F12] font-bold underline hover:text-black"
                >
                  Læs mere om Swisspearl tagløsninger på swisspearl.com
                </a>
              </p>
            </div>

            {/* Byg Garanti og DI Byggeri */}
            <div className="space-y-4 pt-6 border-t border-stone-200">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 uppercase">
                  Byg Garanti og DI Byggeri
                </h2>
                <div className="flex items-center gap-3 self-start sm:self-auto">
                  <img
                    src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-12-thumb.png"
                    alt="Byg Garanti logo"
                    className="h-9 w-auto object-contain"
                  />
                  <img
                    src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-11-thumb.png"
                    alt="DI Byggeri logo"
                    className="h-9 w-auto object-contain"
                  />
                </div>
              </div>
              <p>
                Byg Garanti er en del af DI Byggeri, der er den private forbrugers garanti, hvis der er fejl og mangler ved det arbejde, som er aftalt med en byggevirksomhed.
              </p>
              <p>
                Vi er hos Dansk Tagbyg medlem af DI Byggeri, hvilket betyder, at vores arbejde er dækket af Byg Garanti. Det giver dig som kunde en tryghed i vores arbejde, da du altid er sikret et godt resultat, der lever op til vilkårene i branchen.
              </p>
              <p className="pt-2 flex flex-wrap gap-2">
                <span>Læs mere om</span>
                <a
                  href="https://www.byggaranti.dk/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#BE0F12] font-bold underline hover:text-black"
                >
                  Byg Garanti her
                </a>
                <span>eller</span>
                <a
                  href="https://www.danskindustri.dk/brancher/di-byggeri/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#BE0F12] font-bold underline hover:text-black"
                >
                  DI Byggeri her.
                </a>
              </p>
            </div>
          </div>

          {/* Højre kolonne - Kontakt */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-stone-50 border border-stone-200 p-6 sm:p-8 space-y-4">
              <h3 className="text-lg font-bold text-stone-900 uppercase">
                Kontakt mig, Lasse
              </h3>
              <div className="space-y-2 text-sm text-stone-700">
                <p>
                  <strong>Ring:</strong>{' '}
                  <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-semibold hover:underline">
                    {COMPANY_INFO.phoneFormatted}
                  </a>
                </p>
                <p>
                  <strong>Skriv:</strong>{' '}
                  <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-semibold hover:underline">
                    {COMPANY_INFO.email}
                  </a>
                </p>
              </div>
              <a
                href="#kontakt"
                className="inline-block w-full text-center px-6 py-3 bg-[#BE0F12] hover:bg-[#a00d0f] text-white font-bold text-sm tracking-wider uppercase transition-colors"
              >
                Kontakt os
              </a>
            </div>

            {/* Lasse profilbillede som på originalen */}
            <div className="flex flex-row items-end justify-center gap-2 sm:gap-3 pt-2">
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/har-du-sporgsmaal.png"
                alt="Har du spørgsmål, så tag fat i mig!"
                className="w-[42%] max-w-[145px] h-auto object-contain self-start"
              />
              <img
                src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/lasse-sidebar.png"
                alt="Lasse Vesterhouen - Dansk Tagbyg"
                className="w-[58%] max-w-[200px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bund: Anmeldelser og Kontaktformular (som på originalen) */}
      <section id="kontakt" className="py-16 sm:py-24 bg-stone-100 border-t border-stone-200 scroll-mt-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 sm:gap-16 items-start">
            
            {/* Venstre kolonne: Firmaoplysninger og Anmeld Håndværker */}
            <div className="lg:col-span-5 space-y-8">
              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-3">
                <div className="flex items-center gap-1 text-amber-500 text-lg">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                </div>
                <a
                  href="https://www.anmeld-haandvaerker.dk/tagdaekker/dansk-tagbyg-aps"
                  target="_blank"
                  rel="noreferrer"
                  className="block font-black text-xl text-stone-900 hover:text-[#BE0F12] transition-colors"
                >
                  4,8 ud af 155 anmeldelser
                </a>
                <p className="text-xs text-stone-500">
                  Finalist til Årets Håndværker 5 år i træk
                </p>
              </div>

              <div className="p-6 bg-white border border-stone-200 shadow-sm space-y-4 text-sm text-stone-700">
                <h3 className="font-extrabold text-xl text-stone-900 uppercase">
                  Dansk Tagbyg ApS
                </h3>
                <div className="space-y-2">
                  <p>
                    <strong className="text-stone-900">Ring:</strong>{' '}
                    <a href={`tel:${COMPANY_INFO.phone}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.phoneFormatted}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Skriv:</strong>{' '}
                    <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#BE0F12] font-bold hover:underline">
                      {COMPANY_INFO.email}
                    </a>
                  </p>
                  <p>
                    <strong className="text-stone-900">Adr:</strong> {COMPANY_INFO.address}
                  </p>
                  <p>
                    <strong className="text-stone-900">CVR:</strong> {COMPANY_INFO.cvr}
                  </p>
                </div>
                <div className="pt-3 border-t border-stone-200">
                  <p className="font-bold text-stone-900">Vi løser opgaver i hele DK</p>
                </div>
                <div className="pt-2">
                  <p className="text-xs font-bold text-stone-500 uppercase tracking-wider mb-2">Vi er medlem af</p>
                  <div className="flex flex-wrap items-center gap-3">
                    <img
                      src="/_assets/swisspearl-logo.png"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = 'https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/swisspearl-logo.png';
                      }}
                      alt="Swisspearl"
                      className="h-7 sm:h-8 w-auto object-contain"
                    />
                    <img
                      src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-12-thumb.png"
                      alt="Byg Garanti"
                      className="h-6 w-auto object-contain"
                    />
                    <img
                      src="https://assets.auxodev.dk/assets/78966fd0-599e-4938-a2ab-b403c14ab21e/imgi-11-thumb.png"
                      alt="DI Byggeri"
                      className="h-6 w-auto object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Højre kolonne: Kontaktformular */}
            <div className="lg:col-span-7 bg-white border border-stone-200 p-8 sm:p-10 shadow-sm">
              <ContactForm idPrefix="warranties" submitButtonText="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
